import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnumEnquiryCancelledReason } from '@simplyfly/shared';
import { getEnumEnquiryCancelledReasonLabel } from 'src/app/enums/enquiry-cancelled-reason.helpers';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-enquiry-cancelled-modal',
    templateUrl: './enquiry-cancelled-modal.component.html',
    styleUrls: ['./enquiry-cancelled-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, TranslateModule]
})
export class EnquiryCancelledModalComponent implements OnChanges {
  @ViewChild('modalCancelled', { static: false }) modalCancelledElement: ElementRef;

  @Input() reasonCancelled: { reason?: EnumEnquiryCancelledReason; comment?: string } | null = null;

  @Output() saveCancelled = new EventEmitter<{
    reason: EnumEnquiryCancelledReason;
    comment: string;
  }>();

  formStatusCancelled: FormGroup;

  getEnumEnquiryCancelledReasonLabel = getEnumEnquiryCancelledReasonLabel;

  constructor(private formBuilder: FormBuilder) {
    this.formStatusCancelled = this.formBuilder.group({
      reason: [null, [Validators.required]],
      comment: ['']
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.reasonCancelled) {
      this.patchFormFromReason();
    }
  }

  getCancelledReasons(): EnumEnquiryCancelledReason[] {
    return Object.values(EnumEnquiryCancelledReason);
  }

  showModal(): void {
    this.patchFormFromReason();
    window.$(this.modalCancelledElement.nativeElement).modal('show');
  }

  hideModal(): void {
    if (this.modalCancelledElement) {
      window.$(this.modalCancelledElement.nativeElement).modal('hide');
    }
  }

  save(): void {
    if (this.formStatusCancelled.disabled || !this.formStatusCancelled.valid) {
      return;
    }

    this.hideModal();

    this.saveCancelled.emit({
      reason: this.formStatusCancelled.value.reason,
      comment: this.formStatusCancelled.value.comment
    });

    this.formStatusCancelled.reset();
  }

  private patchFormFromReason(): void {
    this.formStatusCancelled.reset();

    if (this.reasonCancelled?.reason) {
      this.formStatusCancelled.get('reason').setValue(this.reasonCancelled.reason);
    }

    if (this.reasonCancelled?.comment) {
      this.formStatusCancelled.get('comment').setValue(this.reasonCancelled.comment);
    }

    this.formStatusCancelled.updateValueAndValidity();
  }
}
